export default __webpack_public_path__ + "static/media/not-authorized-dark.0e720428.svg";